import React, { Component } from 'react';

import { Box, Table, TableRow, TableBody, TableCell,  TableHead, IconButton, MenuItem, Menu, Fab} from '@mui/material';
import { isEmpty } from 'lodash';
import { grey, amber, red } from '@mui/material/colors';
import TableWithFilters from '../../../common/TableWithFilters';
import EquipementSingle from '../../Equipements/Single/EquipementSingle';
import { AddRounded, MoreVertRounded } from '@mui/icons-material';
import Restitution from '../../Equipements/Forms/Restitution';
import Attribution from '../../Equipements/Forms/Attribution';
import TitleWithEndAction from '../../../common/TitleWithEndAction';


class UserLoans extends Component {
    state = { 
        selected: {},
        openFilters: false,
        openSingle: false,
        openAttribute: false,
        openReturn: false,
        EQUIP: {},
        defaultItem: {},
        list: []
    }
    componentDidMount = async() => {
        const { LOANS_BY_USER } = this.props;
        // TO DO
        // FETCH USER LOAN LIST !OVER
     
        if(isEmpty(LOANS_BY_USER[this.props.userID])){
            await this.props.fetchUserLoansAdmin(this.props.userID)
        }
        
        let list = []
        !isEmpty(LOANS_BY_USER[this.props.userID]) && Object.values(LOANS_BY_USER[this.props.userID]).filter(loan => loan.loan_status != "RESA_CANCELED").forEach(row => {
            let info = {}
            Object.assign(info, row.equipement, row)
            list.push(info)
        })
        this.setState({list})
        console.log('====================================');
        console.log({list});
        console.log('====================================');
    }
    // getFinishedLoanList = () => {

    // }

    getRowStyle = (params) => {
        const value = params.getValue(params.id, 'is_over');
        console.log('====================================');
        console.log({value});
        console.log('====================================');
        if (value === false) {
          return { backgroundColor: amber[50] };
        }
        if (value === true) {
          return { backgroundColor: grey[50] };
        }
        return {};
    };

    render() {
        const { LOANS_BY_USER } = this.props;
        const { list, openSingle, EQUIP, selected, anchorEl, openMenu, openPrint,  openAttribute, openReturn, defaultItem } = this.state;

        return (
            <Box>
                
                <TitleWithEndAction
                    title={"Historique des Emprunts"}
                >
                    <Fab 
                        color={"secondary"} 
                        onClick={() => this.setState({ openAttribute: true })} 
                        title="Nouvelle Attribution"
                        size="small"
                    >
                        <AddRounded />
                    </Fab>
                </TitleWithEndAction>
                {openSingle && EQUIP &&
                    <EquipementSingle
                        {...this.props}
                        {...this.state}
                        close={() => this.setState({ openSingle: false, EQUIP: {}, field: ""})}
                    />
                
                }
                {openAttribute && 
                    <Attribution
                        handleClose={()=> this.setState({ openAttribute: false, defaultItem: {} })}
                        defaultItem={defaultItem}
                        {...this.props}
                        // type={this.state.type}
                    />
                }
                {openReturn && 
                    <Restitution
                        handleClose={()=> this.setState({ openReturn: false, defaultItem: {} })}
                        {...this.props}
                        defaultItem={defaultItem}
                        // type={this.state.type}
                    />
                }
                <Box p={1}>
                    {/* <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell>Date d'Emprunt</TableCell>
                                <TableCell>Retour Prévue</TableCell>
                                <TableCell>Retour</TableCell>
                                <TableCell>Intitulé</TableCell>
                                <TableCell>Marque</TableCell>
                                <TableCell>Référence</TableCell>
                                <TableCell>Rendu</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {!isEmpty(LOANS_BY_USER[this.props.userID]) && Object.values(LOANS_BY_USER[this.props.userID]).map(loan =>
                                <TableRow 
                                    style={{ backgroundColor: (loan.is_over ? grey[400] : (new Date() > new Date(loan.loan_estimated_return) ? red[50] : amber[50])) }}    
                                >
                                    <TableCell>{new Date(loan.loan_start_date).toLocaleDateString("fr-FR")}</TableCell>
                                    <TableCell style={(new Date() > new Date(loan.loan_estimated_return) && !loan.is_over) ? { fontWeight: "bolder", color: "darkred"} : null}>
                                        { new Date(loan.loan_estimated_return).toLocaleDateString("fr-FR") }  
                                    </TableCell>
                                    <TableCell>{new Date(loan.loan_end_date).getFullYear() > 1 ? new Date(loan.loan_end_date).toLocaleDateString("fr-FR") : "--"}</TableCell>
                                    <TableCell className="a-like" >{loan.equipement.equipement_name}</TableCell>
                                    <TableCell className="a-like" >{loan.equipement.equipement_brand}</TableCell>
                                    
                                    <TableCell>{loan.equipement.equipement_unique_ref || loan.equipement.equipement_ref}</TableCell>
                                    <TableCell>
                                        {loan.is_over ? "OUI" : "NON"}
                                    </TableCell>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table> */}
                    
                        { !isEmpty(list) && 
                            <TableWithFilters
                                internalId="loan_id"
                                rows={list.filter(loan => !loan.loan_status.startsWith("RESA"))}
                                rowHeight={50}
                                // rows={Object.values(LOANS_BY_USER[this.props.userID])}
                                // getRowStyle={this.getRowStyle}
                                columns={[
                                    { field: 'equipement_ref', headerName: 'Référence', width: 200 },
                                    {
                                        field: 'equipement_name',
                                        headerName: 'Intitulé', 
                                        width: 300,
                                        renderCell: (params) => (
                                            <span 
                                                className="a-like" 
                                                onClick={
                                                    () => this.setState({EQUIP:params.row, openSingle: true})
                                                }
                                            >
                                                {params.row.equipement_name}
                                            </span>
                                        ),
                                    },
                                    {
                                        field: 'equipement_brand',
                                        headerName: 'Marque', 
                                        width: 300,
                                        renderCell: (params) => (
                                            <span 
                                                className="a-like" 
                                                onClick={
                                                    () => this.setState({EQUIP:params.row, openSingle: true})
                                                }
                                            >
                                                {params.row.equipement_brand}
                                            </span>
                                        ),
                                    },
                                    {
                                        field: 'loan_start_date',
                                        headerName: "Date Emprunt", 
                                        // valueGetter: (params) => `${new Date(params.row.loan_start_date).toLocaleDateString("fr-FR")}`,
                                        renderCell: (params) => (
                                            <span>{
                                                new Date(params.row.loan_start_date).getFullYear() > 1 ? 
                                                `${new Date(params.row.loan_start_date).toLocaleDateString("fr-FR")}` : 
                                                "--"
                                            }
                                            </span>
                                        ),
                                        width: 150
                                    },
                                    {
                                        field: 'loan_end_date',
                                        headerName: "Date Retour", 
                                        // valueGetter: (params) => `${new Date(params.row.loan_end_date).toLocaleDateString("fr-FR")}`,
                                        renderCell: (params) => (
                                            <span>{
                                                new Date(params.row.loan_end_date).getFullYear() > 1 ? 
                                                `${new Date(params.row.loan_end_date).toLocaleDateString("fr-FR")}` : 
                                                "--"
                                            }
                                            </span>
                                        ),
                                        width: 150
                                    },
                                    {
                                        field: 'dispo',
                                        headerName: 'Rendu', 
                                        width: 100,
                                        sortable: true,
                                        valueGetter: (params) => `${params.row.is_over ? 'OUI' : 'NON'}`,
                                    },
                                    {
                                        field: 'actions',
                                        headerName: 'Actions',
                                        sortable: false,
                                        width: 100,
                                        renderCell: (params) => (
                                            
                                            <>
                                            <IconButton 
                                                aria-controls={`option-menu${params.row.equipement_id}`} 
                                                aria-haspopup="true"
                                                onClick={(event) => this.setState({ anchorEl: event.currentTarget, openMenu : params.row.equipement_id}) }>
                                                <MoreVertRounded />
                                            </IconButton>

                                            <Menu
                                                MenuListProps={{
                                                'aria-labelledby': 'basic-button',
                                                }}
                                                id={`option-menu${params.row.equipement_id}`}
                                                anchorEl={anchorEl}                                               
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'right',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                                open={ openMenu === params.row.equipement_id}
                                                onClose={() => this.setState({ openMenu: "", anchorEl: null})}
                                            >
                                                {!params.row.equipement_available && !params.row.no_loan &&
                                                    <MenuItem onClick={() => this.setState({ openReturn: true, defaultItem : params.row}) } >Restitution</MenuItem>    
                                                }   
                                                {params.row.equipement_available &&
                                                    <MenuItem onClick={() => this.setState({ openAttribute: true, defaultItem : params.row}) } >Attribution</MenuItem>    
                                                }
                                            </Menu>
                                            </>
                                        ),
                                    },
                                    
                                ]}
                            />
                        }
                </Box>
            </Box>                
        );
    }
}

export default UserLoans;